/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import "../../../../css/ringMeasure.css";
let $ = window.$;

class RingMeasure extends React.Component {
  componentDidUpdate() {
    $(".optionBoxes>a").on("click", function() {
      $(".optionBoxes>a").removeClass("select");
      $(this).addClass("select");
    });
  }
  handleClick(e) {
    if (e.target.className.match("notAvailable")) {
      $(".outOfStockForm_wrap")
        .finish()
        .fadeIn();
    } else {
      $(".outOfStockForm_wrap")
        .finish()
        .fadeOut();
    }
  }
  getClass(ringStatus) {
    return (ringStatus === "notAvailable" && "notAvailable") || "";
  }
  render() {
    const { ringMeasure } = this.props;
    return (
      <div className="detailsSection ringMeasure_wrap small-txt-link-wrap">
        <p className="subtitle">
          <span>圈度</span>
        </p>
        <div className="optionBoxes">
          {ringMeasure.map((ring, index) => (
            <a
              key={ring.size}
              className={this.getClass(ring.status)}
              onClick={e => this.handleClick(e)}                            
            >
              <span className={this.getClass(ring.status)}>{ring.size}</span>
            </a>
          ))}

          <a
            className="ringMeasureGuide"
            data-toggle="modal"
            data-target="#modal_sizeGuide"
          >
            <span>
              <span className="icon-ruler" />
              <br />
              <span className="text">圈度指南</span>
            </span>
          </a>
        </div>
        <div className="measureNotFound_wrap">
          <a href="/" className="content-link">
            無法找到你的尺寸
          </a>
        </div>
      </div>
    );
  }
}
export default RingMeasure;
